"use strict";

exports.__esModule = true;
exports.default = createId;

var id = 0;

/**
 * Generate an (incrementing) id
 * @returns {number}
 */
function createId() {
  id++;
  return id;
}